var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path4, _g9, _g0, _g1, _path5, _path6, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 311.908h512v102.988a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.896V311.908z",
    fill: "#41479b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 88.276h494.345a8.829 8.829 0 0 1 8.828 8.828v102.988H0V97.104a8.829 8.829 0 0 1 8.828-8.828z",
    fill: "#ff4b55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 200.09h512V311.9H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.21 203.03h24.717v28.25H194.21zM243.64 203.03h24.717v28.25H243.64zM218.92 231.28h24.717v28.25H218.92zM293.07 203.03h24.717v28.25H293.07zM268.36 231.28h24.717v28.25H268.36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.92 203.03h24.717v28.25H218.92zM268.36 203.03h24.717v28.25H268.36zM194.21 231.28h24.717v28.25H194.21zM243.64 231.28h24.717v28.25H243.64zM293.07 231.28h24.717v28.25H293.07z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.64 259.53h24.717v28.25H243.64zM218.92 287.78h24.717v28.25H218.92zM268.36 287.78h24.717v28.25H268.36z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.92 259.53h24.717v28.25H218.92zM268.36 259.53h24.717v28.25H268.36zM243.64 287.78h24.717v28.25H243.64z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.792 203.035v79.448c0 34.127-27.666 61.793-61.793 61.793s-61.793-27.666-61.793-61.793v-79.448h123.586m4.414-4.414H189.792v83.862c0 36.506 29.7 66.207 66.207 66.207s66.207-29.7 66.207-66.207v-83.862z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.924 287.779v-28.248h-24.717v22.952c0 1.789.118 3.546.267 5.297h24.45v-.001z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.525 287.779h-24.45v28.248h14.774a61.348 61.348 0 0 0 9.676-28.248zM204.15 316.027h14.774V287.78h-24.45a61.36 61.36 0 0 0 9.676 28.247z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.075 287.779h24.45c.149-1.749.267-3.508.267-5.297V259.53h-24.717v28.249zM218.924 331.833v-15.806H204.15c3.959 6.107 8.973 11.441 14.774 15.806zM307.849 316.027h-14.774v15.806c5.802-4.365 10.816-9.699 14.774-15.806z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.924 331.833c7.194 5.415 15.567 9.345 24.717 11.202v-27.008h-24.717v15.806zM268.358 343.035c9.15-1.857 17.523-5.788 24.717-11.202v-15.806h-24.717v27.008z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.358 316.027h-24.717v27.008A62.043 62.043 0 0 0 256 344.276c4.233 0 8.365-.43 12.359-1.241v-27.008h-.001z",
    fill: "#ff4b55"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#4173cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.27 156.292a180.927 180.927 0 0 0-16.489-1.779 189.969 189.969 0 0 0-12.398 11.15l11.823 28.545a161.456 161.456 0 0 1 24.247-7.866l-7.183-30.05zM271.003 151.605a184.939 184.939 0 0 0-15.002-6.765 185.474 185.474 0 0 0-15.002 6.765l2.41 30.803a161.163 161.163 0 0 1 25.186 0c.801-10.268 1.605-20.535 2.408-30.803zM329.616 165.663a190.81 190.81 0 0 0-12.398-11.15c-5.609.346-11.111.947-16.489 1.779l-7.183 30.049a161.57 161.57 0 0 1 24.247 7.866l11.823-28.544z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.997 151.605a183.1 183.1 0 0 0-15.894-4.346 187.354 187.354 0 0 0-13.832 9.033c2.394 10.017 4.789 20.033 7.185 30.049a161.442 161.442 0 0 1 24.952-3.933l-2.411-30.803zM300.729 156.292a187.242 187.242 0 0 0-13.832-9.033 183.718 183.718 0 0 0-15.894 4.346l-2.41 30.803a161.322 161.322 0 0 1 24.952 3.933l7.184-30.049z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff4b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.96 163.926a179.702 179.702 0 0 0-27.817 4.385l-1.437-6.01a186.473 186.473 0 0 1 28.771-4.535l.483 6.16zM242.925 176.247a167.663 167.663 0 0 0-25.907 4.084l-1.437-6.009a173.602 173.602 0 0 1 26.862-4.234l.482 6.159z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.326 178.321a167.55 167.55 0 0 0-6.482-1.022c-3.562-.492-6.215-3.516-5.906-6.915.308-3.398 3.713-5.863 7.59-5.327 2.325.32 4.645.685 6.959 1.097 3.859.682 6.357 4.082 5.604 7.406-.751 3.331-4.217 5.386-7.765 4.761z",
    fill: "#ffe15a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M320.157 188.498a167.81 167.81 0 0 0-25.175-8.168l1.437-6.009a173.739 173.739 0 0 1 26.103 8.468l-2.365 5.709z",
    fill: "#ff4b55"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.952 169.96c-.873 2.407-3.817 3.552-6.599 2.647-2.781-.906-4.483-3.55-3.779-6.012s3.686-3.765 6.636-2.806c2.953.957 4.615 3.764 3.742 6.171zM204.425 166.596c.703 2.464-1 5.109-3.779 6.012-2.781.9-5.725-.245-6.599-2.647-.874-2.408.79-5.214 3.742-6.17 2.949-.957 5.934.344 6.636 2.805zM254.59 162.549c.006 2.047-1.834 3.714-4.114 3.784-2.279.073-4.222-1.481-4.342-3.52-.119-2.04 1.719-3.806 4.111-3.883 2.392-.075 4.335 1.572 4.345 3.619zM265.865 162.813c-.121 2.044-2.065 3.593-4.342 3.52-2.279-.07-4.119-1.737-4.114-3.784.009-2.045 1.953-3.697 4.344-3.619 2.393.072 4.23 1.842 4.112 3.883zM260.007 172.08c-.057 2.047-1.85 3.657-4.008 3.657-2.156-.001-3.949-1.609-4.008-3.657-.056-2.041 1.737-3.755 4.008-3.749 2.271-.005 4.064 1.707 4.008 3.749z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/hr.221432cecdac3a626db6dd91be4e896b.svg";
export { ForwardRef as ReactComponent };